import * as Campaigns from '../campaigns';
import * as Groups    from '../groups';
import * as Templates from '../campaign_templates';
import ComposePage    from './compose_page';
import NotFoundPage   from '../components/not_found_page';
import React          from 'react';
import WaitFor        from '../components/wait_for';


export default function EditPage({ businessID, campaignID }) {
  const statuses      = [
    Campaigns.useCampaignsStatuses(businessID),
    Templates.useTemplatesStatuses(businessID),
    Groups.useGroupsStatuses(businessID)
  ];
  const initialRecord = Campaigns.useCampaign(campaignID);
  const pageTitle     = 'Edit Campaign';

  return (
    <WaitFor statuses={statuses}>
      {initialRecord && <ComposePage {...{ businessID, initialRecord, pageTitle }}/>}
      {!initialRecord && <NotFoundPage title="Campaign not found."/>}
    </WaitFor>
  );
}
